import OmbudsmanForm from './OmbudsmanForm';

export default OmbudsmanForm;
